import React, { useRef } from 'react'
import { useHistory } from 'react-router'
import classnames from 'classnames'

import { BackButton, InputImage, UikButton } from 'components'
import constants from 'helpers/constants'
import cls from '../EventForm.module.scss'
import CardHeader from '../components/CardHeader'
import eventImagePlaceholder from 'assets/images/eventImagePlaceholder.png'
import FieldTitle from '../components/FieldTitle'

const {
  EVENT_CONSTANTS: { COVER_IMAGE, VERTICAL_IMAGE },
} = constants

const InfoStep = ({ formState, setFormState, errors }) => {
  const uploadButtonRef = useRef(null)
  const uploadVerticalButtonRef = useRef(null)
  const history = useHistory()

  const preventSubmit = event => {
    if (event.keyCode === 13) {
      event.preventDefault()
      return false
    }
  }

  const handleInputChange = e => setFormState({ [e.target.name]: e.target.value })

  return (
    <div className={cls.cardContainer}>
      <BackButton type="button" buttonMethod={() => history.push('/portal')} />
      <CardHeader
        stepNumber="1"
        title="Create your unique event"
        info="Create a title that communicates the theme that will bring your daters together. Some examples include: Runners in Colorado, Museum Lovers In Manhattan, Pasta Eaters in Roma, Adventurous Nomads in Costa Rica, NYU Grads in Brooklyn"
      />
      <div className={cls.card}>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Event Title" />
          <input
            className={classnames(cls.textInput, {
              [cls.fieldError]: errors.title,
            })}
            placeholder="Keep it short and sweet..."
            name="title"
            onChange={handleInputChange}
            onKeyDown={preventSubmit}
            maxLength="35"
            value={formState.title}
          />
        </div>
        <div className={cls.fieldContainer}>
          <FieldTitle
            title="Event Cover Image"
            showInfoCircle={true}
            info="We require all events to use high resolution images without white backgrounds or text so that they look great when you promote!"
          />
          <div className={cls.uploadImageButtonWrapper}>
            <UikButton
              className={cls.unsplashLink}
              transparent
              onClick={() => window.open('https://unsplash.com')}
            >
              Find HD Images
            </UikButton>
          </div>
          <div className="relative">
            <InputImage
              width={COVER_IMAGE.WIDTH}
              height={COVER_IMAGE.HEIGHT}
              title="Upload Horizontal"
              name="imageData"
              ref={uploadButtonRef}
              onChange={imageData => setFormState({ imageData })}
            />
            <InputImage
              width={VERTICAL_IMAGE.WIDTH}
              height={VERTICAL_IMAGE.HEIGHT}
              title="Upload Vertical"
              name="verticalImageData"
              ref={uploadVerticalButtonRef}
              onChange={verticalImageData => setFormState({ verticalImageData })}
            />
          </div>
        </div>
        <div className="flex flex-col mt-4 space-y-5 md:flex-row md:space-x-5 md:space-y-0">
          <div className="flex-1">
            <UikButton
              className={cls.uploadImageButton}
              onClick={() => uploadButtonRef.current.click()}
            >
              Upload Horizontal
            </UikButton>
            <div
              className={classnames(cls.imagePreview, {
                [cls.fieldError]: errors.imageData,
              })}
              style={{
                backgroundImage: `url("${formState.imageData || eventImagePlaceholder}")`,
              }}
            />
          </div>
          <div className="flex-1">
            <UikButton
              className={cls.uploadImageButton}
              onClick={() => uploadVerticalButtonRef.current.click()}
            >
              Upload Vertical
            </UikButton>
            <div
              className={classnames(cls.imagePreview, {
                [cls.fieldError]: errors.verticalImageData,
              })}
              style={{
                backgroundImage: `url("${formState.verticalImageData || eventImagePlaceholder}")`,
              }}
            />
          </div>
        </div>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Event Description" />
          <textarea
            className={classnames(cls.textArea, {
              [cls.fieldError]: errors.description,
            })}
            rows="5"
            placeholder="Describe the theme of your event in 2-3 sentences. Highlight the interest, passion, faith, culture, or lifestyle that you want to attract."
            maxLength={500}
            name="description"
            onChange={handleInputChange}
            value={formState.description}
          />
        </div>
        <div className={cls.fieldContainer}>
          <FieldTitle title="Event Slug (Admin only)" />
          <input
            className={classnames(cls.textInput, {
              [cls.fieldError]: errors.slug,
            })}
            name="slug"
            onChange={handleInputChange}
            onKeyDown={preventSubmit}
            value={formState.slug}
          />
        </div>
      </div>
    </div>
  )
}

export default InfoStep
